module.exports = [{"value":"Mr.","text":"Mr."},{"value":"Mrs.","text":"Mrs."},{"value":"Miss.","text":"Miss."}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/titleName/titleNameEN.json
// module id = JAYh
// module chunks = 2